export default __webpack_public_path__ + "static/char-s-03-cht-d54ccae31154374c69736d5e0cb58f5c.webp";